import { render, staticRenderFns } from "./AdminAreasForm.vue?vue&type=template&id=f0f8cc34"
import script from "./AdminAreasForm.vue?vue&type=script&lang=js"
export * from "./AdminAreasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports